<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :open-on-click="true"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{}">
      <v-text-field
        clearable
        :label="label"
        ref="date"
        :rules="required ? [(v) => !!v] : []"
        v-model="dateFormatted"
        :dense="$props.dense"
        prepend-icon="event"
        :error="error"
        class="mt-4"
        v-bind="$attrs"
        v-on="inputListeners"
      />
    </template>
    <v-date-picker v-model="date" :min="min" :max="max" @input="menu = false" />
  </v-menu>
</template>

<script>
/* eslint-disable vue/require-default-prop */

import DateMixin from "@/mixins/Date";

export default {
  mixins: [DateMixin],

  inheritAttrs: false,

  props: {
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
    },
    showMenu: {
      default: false,
      type: Boolean,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      required: false,
    },
    max: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      date: this.toDefaultDate(this.value),
      menu: false,
      dateFormatted: this.toUiDate(this.value),
      error: false,
    };
  },
  computed: {
    inputListeners: function () {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          click: function () {
            vm.menu = true;
          },
          blur: function () {
            vm.date = vm.toDefaultDate(vm.dateFormatted);
            vm.$emit("blur");
          },
        }
      );
    },
  },
  watch: {
    value(val) {
      this.date = this.toDefaultDate(val);
    },
    date: {
      handler() {
        this.dateFormatted = this.toUiDate(this.date);
        this.$emit("input", this.date);
      },
    },
    menu(val) {
      if (!val && !this.$refs.date.isFocused) {
        this.$emit("blur");
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.menu = this.showMenu;
    }, 100);
  },
};
</script>
